import React from 'react';
import { FormControl, Select, MenuItem } from '@material-ui/core';

function CountrySelector({ value, handleLocation, all = false }) {
  return (
    <FormControl size='small' style={ { pending: '30px', width: '100%' } }>
      <Select
        variant='outlined'
        size='small'
        labelId='location-select-label'
        id='location-select'
        value={ value }
        onChange={ (e) => { handleLocation(e); } }
      >
        {all && <MenuItem value='All'>All</MenuItem>}
        <MenuItem value='Greece'>Greece</MenuItem>
        <MenuItem value='Albania'>Albania</MenuItem>
        <MenuItem value='India'>India</MenuItem>
        <MenuItem value='Iraq'>Iraq</MenuItem>
      </Select>
    </FormControl>
  );
}

export default CountrySelector;
